import FlexContainerBase from './_flex-container-base.js'
import FlexItemBase from './_flex-item-base.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurableSize from './_configurable-size.js'
import ConfigurablePosition from './_configurable-position.js'

export default {
  name: 'LoaderSuspense',
  values: {
    showLoaderDelay: 500,
    disableLoader: false,
    style: {
      container: {
        position: undefined,
        visibility: undefined,
        $mixin: [
          {
            configSet: FlexContainerBase,
          },
          {
            configSet: FlexItemBase,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
          {
            configSet: ConfigurableSize,
          },
          {
            configSet: ConfigurablePosition,
          },
        ],
      },
      hidden: {
        display: 'none',
        visibility: undefined,
        opacity: undefined,
        position: undefined,
        zIndex: undefined,
        $mixin: [
          {
            configSet: ConfigurableSize,
          },
        ],
      },
    },
  },
  meta: {
    extendable: false,
  },
}
